import { useForm, List } from 'rc-field-form';
import Form from './Form';
import FormItem from './FormItem';
var FormNamespace = Object.assign(Form, {
  Item: FormItem,
  useForm: useForm,
  List: List
});
export default FormNamespace;
export { Form, FormItem };